export default {
    data() {
        return {
            formState: {
                requestType: 'PQ',
                requestTitle: '',
                requestDescription: '',
                requestSectors: [],
                selectedCountry: [],
                requestDeadline: '',
                orderExtras: {
                    currency: '',
                    currencyRequired: '',
                    deliveryNeeded: '',
                    deliveryAddress: '',
                    deliveryTimeNeeded: '',
                    paymentRequired: '',
                    guarantyTime: '',
                    countryRequired: '',
                    initialRequirementNotes: '',
                },
                products: [],
                requestFiles: [],
                requestIsPrivate: 0,
                requestIsPersonalAllowed: 0,
                onlyVerified: 0,
                onlyVendors: 0,
                rfqTerms: 0,
                autoWinner: null,
                vendorIds: [],
            }
        }
    },
    created() {
        const saved = localStorage.getItem('RFQ_FORM')
        if (saved) {
            try {
                this.formState = JSON.parse(saved)
            } catch(e) { /* ignore */ }
        }
    },
    watch: {
        formState: {
            handler(state) {
                localStorage.setItem('RFQ_FORM', JSON.stringify(state))
            },
            deep: true
        }
    }
}
